module.exports = __webpack_public_path__ + "static/media/favourite-unselect.65a77ec9.svg";